import React from 'react';
import {StyleSheet} from 'react-native';

import {useFormikContext} from 'formik';
import AppButton from '../AppButton';

function SubmitButton({title, style}) {
  const {handleSubmit} = useFormikContext();

  return (
    <AppButton
      style={[styles.button, style]}
      title={title}
      onPress={handleSubmit}
    />
  );
}

const styles = StyleSheet.create({
  button: {
    minWidth: '20%',
    height: 40,
    alignSelf: 'center',
    // marginTop: 10,
  },
});

export default SubmitButton;
